
















































































import DictMixin from '@/mixins/dict-mixin';
import DictServices from '@/services/dict';
import ParamsServices from '@/services/params';
import { mixins } from 'vue-class-component';
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class RuleConditionItem extends mixins(DictMixin) {
  @PropSync('item') syncItem!: any;
  @Prop() fieldList!: any;

  paramSrv = new ParamsServices();
  dictSrv = new DictServices();
  created() {
    this.getParamList();
    this.getDictItemList();

    this.onSyncItemChange();
  }

  paramList: any[] = [];
  async getParamList() {
    let list = await this.paramSrv.getEnableList({ paramCategory_eq: 0 });
    this.paramList = list.map((v: any) => ({
      label: v.paramName,
      value: v.paramCode
    }));
  }

  fieldValue: string = '';
  @Watch('fieldValue')
  fieldValueChange(e: string) {
    let [id, type, name] = e.split('/');
    this.syncItem.fieldRefCode = id;
    this.syncItem.dataType = type;
    this.syncItem.fieldName = name;
  }

  @Watch('fieldList', { deep: true })
  onFieldListChange() {
    if (!this.fieldValue) {
      this.fieldValue = `${this.syncItem.fieldRefCode}/${this.syncItem.dataType}/${this.syncItem.fieldName}`;
    }
  }

  @Watch('syncItem.compareStr')
  onCompareStrChange() {
    this.syncItemValue = '';
    this.syncItem.value = '';
  }

  dictItemList: any[] = [];
  async getDictItemList() {
    this.dictItemList = await this.dictSrv.getTree({ dictKind_eq: 0, status_eq: 0 });
  }

  dictValue: string[] = [];
  onChangeDict(e: string[]) {
    let [code, value] = e;
    this.syncItem.dictCode = code;
    this.syncItem.value = value;
  }

  @Watch('syncItem', { deep: true })
  onSyncItemChange() {
    if (this.syncItem.dictCode) this.dictValue = [this.syncItem.dictCode, this.syncItem.value];
    if (this.syncItem.value) this.syncItemValue = this.syncItem.value;
    if (this.syncItem.fieldName) this.fieldValue = `${this.syncItem.fieldRefCode}/${this.syncItem.dataType}/${this.syncItem.fieldName}`;
    if (this.syncItem.compareStr === 'relative') this.syncItem.dictCode = 'DICT_DATE_TYPE';
  }

  syncItemValue: string = '';
  @Watch('syncItemValue')
  onSyncItemValueChange(e: string) {
    this.syncItem.value = e;
  }

  removeRule() {
    this.$emit('remove');
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  refreshParams() {
    this.getParamList();
  }

  refreshDict() {
    this.getDictItemList();
  }
}
